//#region src/menu_cover_promotion_type.ts
let MenuCoverPromotionType = /* @__PURE__ */ function(MenuCoverPromotionType) {
	MenuCoverPromotionType["GCN"] = "gcn";
	MenuCoverPromotionType["CarouselS"] = "carousel-s";
	MenuCoverPromotionType["CarouselM"] = "carousel-m";
	MenuCoverPromotionType["CarouselR"] = "carousel-r";
	MenuCoverPromotionType["SingleS"] = "single-s";
	MenuCoverPromotionType["SingleM"] = "single-m";
	MenuCoverPromotionType["SingleR"] = "single-r";
	MenuCoverPromotionType["GridS"] = "grid-s";
	MenuCoverPromotionType["GridM"] = "grid-m";
	MenuCoverPromotionType["GridR"] = "grid-r";
	return MenuCoverPromotionType;
}({});
//#endregion
export { MenuCoverPromotionType };

//# sourceMappingURL=menu_cover_promotion_type.js.map